var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.GET_ACCOUNT_DATA.id == 1 ||
      _vm.has_perm('create_apartment') ||
      _vm.has_perm('update_apartment')
  )?_c('div',[(
      _vm.GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA.extra_info_list !== undefined &&
      _vm.GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA.extra_info_list.includes(
        _vm.keyCheckShowApartmentExtraInfo
      )
    )?_c('div',[_c('apartment-add-with-extra-info')],1):_c('div',[_c('apartment-add')],1),_vm._v(" "),_vm._l((_vm.GET_SNACK_BAR),function(snackbar){return _c('lte-core-alert',{key:snackbar.id,attrs:{"item":snackbar}})}),_vm._v(" "),_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"color":"#1E90FF"},on:{"update:active":function($event){_vm.isLoading=$event}}})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10a48779","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Apartment/ApartmentDetailTabs.vue
// module id = null
// module chunks = 